(function () {
    'use strict';

    angular
        .module('app')
        .factory('LinePlanService', LinePlanService);


    function LinePlanService($http, $q, $rootScope, WebAPIUrl, WebApiService) {

        var service = {
            getLinePlans: getLinePlans,
            getLinePlansByBrandSeason: getLinePlansByBrandSeason,
            getLinePlanHeaderInfo: getLinePlanHeaderInfo,
            getLinePlanSubSeasons: getLinePlanSubSeasons,
            getLinePlanCalendarItems: getLinePlanCalendarItems,
            isLinePlanNameExists: isLinePlanNameExists,
            updateLinePlan: updateLinePlan,
            updateLinePlanSeasonalPlanningItems: updateLinePlanSeasonalPlanningItems,
            saveCalendarItems: saveCalendarItems,
            saveCalendarItems1: saveCalendarItems1,
            getBrandsByUser: getBrandsByUser,
            getAvailableSeasons: getAvailableSeasons,
            createLinePlan: createLinePlan,
            getLinePlanSeasonalPlanningItems: getLinePlanSeasonalPlanningItems,
            getLinePlanBriefs: getLinePlanBriefs,
            getBriefInfo: getBriefInfo,
            deleteLinePlan: deleteLinePlan,
            searchLinePlans: searchLinePlans,
            exportLinePlans: exportLinePlans,
            getLinePlanLaunchDates: getLinePlanLaunchDates,
            getLinePlanLaunchDateDetails: getLinePlanLaunchDateDetails,
            getLinePlanForPatternSeason: getLinePlanForPatternSeason,
            importCalendar: function (linePlanId, file) {
                return WebApiService.postFile('/api/LinePlan/ImportCalendar/' + linePlanId, file);
            }
        };


        return service;

        function getLinePlanForPatternSeason(patternId, seasonId) {
            return WebApiService.get("/api/LinePlan/GetLinePlanForPatternSeason?patternId=" + patternId + "&seasonId=" + seasonId);
        }

        function getLinePlans() {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/LinePlan/LinePlans',
            }).success(function (data, status, headers, cfg) {
                //console.log(data);
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        //GetSearchableLinePlans(string LinePlanName, int BrandId, int SeasonId, int StatusId)
        function searchLinePlans(searchObject, pageNumber, pageSize, sortColumn, sortDirection) {

            var deferred = $q.defer();
            searchObject.pageNumber = pageNumber;
            searchObject.pageSize = pageSize;
            searchObject.sortColumn = sortColumn;
            searchObject.sortDirection = sortDirection;

            $http({
                method: 'POST',
                url: WebAPIUrl + '/api/LinePlan/SearchLinePlans',
                headers: { 'Content-Type': 'application/json' },
                data: JSON.stringify(searchObject),
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {

                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function exportLinePlans(searchObject, pageNumber, pageSize, sortColumn, sortDirection) {
            searchObject.pageNumber = pageNumber;
            searchObject.pageSize = pageSize;
            searchObject.sortColumn = sortColumn;
            searchObject.sortDirection = sortDirection;

            return WebApiService.postJson("/api/LinePlan/ExportLinePlans", searchObject);
        }

        function getLinePlansByBrandSeason(brandId, seasonId, linePlanId) {
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/LinePlan/LinePlansByBrandSeason?BrandId=' + brandId + '&SeasonId=' + seasonId + '&LinePlanId=' + linePlanId,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                //console.log(data);
                deferred.resolve(data);

            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getLinePlanHeaderInfo(linePlanId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/LinePlan/LinePlanHeaderDetails?LinePlanId=' + linePlanId,
                data: linePlanId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                alert('error');
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getLinePlanSubSeasons(linePlanId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/LinePlan/LinePlanSubSeasons?LinePlanId=' + linePlanId,
                data: linePlanId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                alert('error');
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getLinePlanCalendarItems(calendarId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/LinePlan/LinePlanCalendarItems?CalendarId=' + calendarId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                alert('error');
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function isLinePlanNameExists(linePlanId, linePlanName, brandId, seasonId) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/LinePlan/IsLinePlanNameExists?LinePlanId=' + linePlanId + '&LinePlanName=' + linePlanName + '&BrandId=' + brandId + '&SeasonId=' + seasonId,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function updateLinePlan(linePlanData, linePlanLaunchDatesData) {
            return WebApiService.postJson("/api/LinePlan/UpdateLinePlan", { linePlan: linePlanData, launchDates: linePlanLaunchDatesData });
        }

        function updateLinePlanSeasonalPlanningItems(linePlanSeasonalPlanningItems) {

            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/LinePlan/UpdateLinePlanSeasonalPlanningItems",
                data: { '': linePlanSeasonalPlanningItems },
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function saveCalendarItems(calendarItemData) {

            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/LinePlan/SaveCalendarItems",
                data: { '': calendarItemData },
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function saveCalendarItems1(calendarItemData, calendarItemData1) {

            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/LinePlan/SaveCalendarItems1",
                data: { item1: calendarItemData, item2: calendarItemData1 },
                ignoreLoadingBar: true
                //param: { '': calendarItemData,'':calendarItemData1 },
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }



        function getBrandsByUser() {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Brand/GetBrandsByUser'
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                alert('error');
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getAvailableSeasons(brandId) {
            return WebApiService.get("/api/LinePlan/GetAvailableSeasons?BrandId=" + brandId);
        }

        function createLinePlan(linePlanData, calendarData) {
            return WebApiService.postJson("/api/LinePlan/CreateLinePlan", { item1: linePlanData, item2: calendarData }, "", false);
        }

        function getLinePlanSeasonalPlanningItems(linePlanId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/LinePlan/GetLinePlanSeasonalPlanningItems?LinePlanId=' + linePlanId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getLinePlanBriefs(linePlanId, ignoreLoader) {
            if (ignoreLoader == undefined) {
                ignoreLoader = false;
            }
            var deferred = $q.defer();
            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/LinePlan/LinePlanBriefs?LinePlanId=' + linePlanId,
                ignoreLoadingBar: ignoreLoader
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

        function getBriefInfo(briefSeasonalId) {
            return WebApiService.get('/api/LinePlan/GetBriefInfo', { briefSeasonalId: briefSeasonalId });
        }

        function deleteLinePlan(linePlanId) {

            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + '/api/LinePlan/DeleteLinePlan?LinePlanId=' + linePlanId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getLinePlanLaunchDates(calendarId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/LinePlan/LinePlanLaunchDates?CalendarId=' + calendarId,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getLinePlanLaunchDateDetails(linePlanLaunchDateId) {

            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/LinePlan/LinePlanLaunchDateDetails?LinePlanLaunchDateId=' + linePlanLaunchDateId
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                alert('error');
                deferred.reject(err, status);
            });

            return deferred.promise;

        }

    }

})();
